import { InfiniteData } from '@tanstack/query-core';
import { useMutation } from '@tanstack/react-query';
import { Article, type ArticlesPaginatedList } from '@shared/types/articles';
import { UpdateArticleDto } from '@src/api/articles.ts';
import { API } from '@src/api/index.ts';
import { queryClient } from '@src/api/query-client.ts';

export const useUpdateArticleMutation = () => {
  return useMutation({
    mutationFn: async (params: UpdateArticleDto) => await API.articles.update(params),
    onSuccess: (response) => {
      queryClient.setQueriesData(
        { queryKey: ['articles'] },
        (oldData: InfiniteData<ArticlesPaginatedList>) => {
          if (!oldData) return oldData;
          return {
            ...oldData,
            pages: oldData.pages.map((page) => ({
              ...page,
              results: page.results.map((item) =>
                item.id === response.data.id ? { ...item, ...response.data } : item
              ),
            })),
          };
        }
      );

      queryClient.setQueriesData(
        { queryKey: ['article', String(response.data.id)] },
        (oldData: Article) => {
          if (!oldData) return oldData;
          return {
            ...oldData,
            ...response.data,
          };
        }
      );
      queryClient.invalidateQueries({ queryKey: ['article', String(response.data.id)] });
      queryClient.invalidateQueries({ queryKey: ['articles'] });
    },
  });
};
